import React, { ReactElement } from 'react';
import { Modal } from 'react-bootstrap';
import { LiveBlock } from '../../../live/components/LiveBlock/LiveBlock';
import { LiveBlockForMatchProps } from '../LiveMatchListModal/LiveMatchListModal';
import './ViewAnotherLiveMatchModal.scss';

export interface PropsViewAnother {
  isShow: boolean;
  liveMatches?: LiveBlockForMatchProps;
  closeModal: (child: boolean) => void;
}

const ViewAnotherLiveMatchModal = (props: PropsViewAnother): ReactElement => {
  const { isShow, liveMatches, closeModal } = props;

  return (
    <Modal
      show={isShow}
      onHide={() => {
        closeModal(false);
      }}
    >
      <Modal.Body>
        <div className="root-view-another-live-match">
          <div className="view-another-live-match__title">
            <h4>どちらの配信を見に行きますか？</h4>
            <p>今の配信から退室しますが、後から戻ることができます。</p>
          </div>
          {liveMatches && (
            <div className="view-another-live-match__block">
              <LiveBlock live={liveMatches.live} />
              <LiveBlock live={liveMatches.target} />
            </div>
          )}
          <div
            onClick={() => {
              closeModal(false);
            }}
            className="view-another-live-match__cancel"
          >
            キャンセル
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ViewAnotherLiveMatchModal;
